export const faqData = [
    {
        id: "01",
        question:
            " Are Native Apps safe?",
        answer:"Yes. Native apps are inherently more secure because they use the OS’s built-in security layers directly. We implement hardware-backed encryption and biometric auth (FaceID/TouchID) that web-based shells cannot match."
    }, 
    {
        id: "02",
        question:
            "When should I choose native over cross-platform?",
        answer:"Choose native if your app requires high performance (games/streaming), complex hardware access (IoT), or a premium feel. If your budget is tight and the app is mostly simple forms and text, cross-platform might suffice."
    }, 
    {
        id: "03",
        question:
            " Is native development ROI worth the higher cost?",
        answer:"Absolutely. While the upfront cost is higher, native apps have lower long-term maintenance costs because they don't rely on third-party frameworks that break during OS updates. Better performance also leads to higher user retention and better store rankings."
    }, 
    {
        id: "04",
        question:
            "Can you migrate my existing hybrid app to native?",
        answer:"Yes. We perform a full performance audit and feature mapping to ensure a seamless transition with zero data loss for your current users."
    }, 
    {
        id: "05",
        question:
            "Do I need separate developers for iOS and Android? ",
        answer:"While the codebases are separate, we provide a unified project management team. You get the benefit of specialized Swift and Kotlin experts working in sync under one point of contact."
    }, 

];